/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

import loadingConfig from "./config/loading.config.json";

const is = require("is_js");

const SERVICE_NAME = "AssetDetailPageService";
const log: any = LoggerModule.getInstance();

export class AssetDetailPageService {
  private static instance: AssetDetailPageService;
  private vapp: VApplication;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): AssetDetailPageService {
    if (!AssetDetailPageService.instance) {
      AssetDetailPageService.instance = new AssetDetailPageService(props);
    }
    return AssetDetailPageService.instance;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getHeaderProfileContent(args: {}) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    //Header Props
    compProps = await agent.getHeaderProps();
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //ProfileCard section Props

    // compProps = await agent.getProfileCardSectionProps();
    // if (compProps) {
    //   content = { ...content, ...compProps };
    // }

    return content;
  }

  public async getPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    //UserLists Props
    compProps = await agent.getAssetDetailProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public getLoading() {
    return { ...(loadingConfig || {}) };
  }
}
